const fields = [
  { label: "fileUploads", order: 1, type: "file" },
  {
    label: "email",
    placeholder: "Correo Electrónico",
    order: 2,
    type: "email",
    isRequired: true,
  },
  {
    label: "firstName",
    placeholder: "Nombre",
    order: 3,
    type: "text",
    isRequired: true,
  },
  {
    label: "lastName",
    placeholder: "Apellidos",
    order: 4,
    type: "text",
    isRequired: true,
  },
  {
    label: "instagramUsername",
    placeholder: "Usuario de Instagram",
    order: 5,
    type: "text",
    isSocialMedia: true,
    isRequired: false,
  },
  {
    label: "profession",
    placeholder: "Profesion",
    order: 6,
    type: "text",
    isSocialMedia: false,
    isRequired: true,
  },
  {
    label: "product",
    placeholder: "Productos representados",
    order: 7,
    type: "text",
    isSocialMedia: false,
    isRequired: false,
  },
  {
    label: "tipsProfession",
    placeholder: "Tipos de creaciones",
    order: 8,
    type: "text",
    isSocialMedia: false,
    isRequired: false,
  },
];

export default fields;
